import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import layoutReducer from './slices/layoutSlice'
import companyReducer from './slices/companySlice'
import entityReducer from './slices/entitySlice'
import userReducer from './slices/userSlice'
import truckReducer from './slices/truckSlice'
import driverReducer from './slices/driverSlice'
import transportRequestReducer from './slices/transportRequestSlice'
import biltyReducer from './slices/biltySlice'

const store = configureStore({
  reducer: {
    auth: authReducer,
    Layout: layoutReducer,
    company: companyReducer,
    entity: entityReducer,
    user: userReducer,
    truck: truckReducer,
    driver: driverReducer,
    transportRequest: transportRequestReducer,
    bilty: biltyReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/login/fulfilled'],
      },
    }),
})

export default store
